var map = {
	"./Artboard 51@3x.png": 52276,
	"./Basimart_Loader.gif": 47043,
	"./basi-short-logo.png": 65040,
	"./basi.png": 29580,
	"./basicheckout.png": 49958,
	"./clock.png": 52211,
	"./deals.png": 42984,
	"./emptycart.png": 48469,
	"./guaranteeIcon.png": 21703,
	"./list.png": 77004,
	"./logo.png": 66949,
	"./logo1.png": 36458,
	"./logo3.png": 26665,
	"./logo4.png": 63775,
	"./marker.png": 7676,
	"./recipies.png": 80185,
	"./retry.png": 47920,
	"./shop.png": 71680,
	"./story-basimax.png": 98099,
	"./story-fruits.png": 48702,
	"./story-offer.png": 9956,
	"./story-veg.png": 69136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;